/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'g_security': {
    width: 16,
    height: 16,
    viewBox: '0 0 54.64 56.69',
    data: '<path pid="0" d="M28.35 56.69a28.35 28.35 0 1122.29-45.87l-2.81 2.22a24.77 24.77 0 10.66 29.73l2.9 2.09a28.43 28.43 0 01-23 11.83" _fill="#fff"/><path pid="1" d="M16.68 41.49h-3.74V27.22h3.74v5.26l6.55 3 2.84-5.55-7.34-3.29 6.69-12.41 24.43 10.93-1.42 2.62 6.21 2.8-4 7.46-6.21-2.78-1.28 2.32-13.66-6.13-4.57 8.89-8.24-3.76zm31.15-8.81l1.15.51.47-.86-1.15-.52zm-16.64-4.55l10.37 4.62 3.14-5.83-17.63-7.88-3.15 5.83 3.86 1.71 2.1-4.08 3.32 1.7z" _fill="#fff"/>'
  }
})
